/* istanbul ignore file */
/* eslint-disable no-undef */

export default {
  computed: {
    isMobile() {
      return window.location.hostname.indexOf('m.') === 0;
    },
  },
};
